import { ICoreAppOnboardingState } from "@/apps/core-app-onboarding/types/ICoreAppOnboardingState";

/**
 * MUTATIONS
 */
const mutations = {
  INIT_STATE: (
    state: ICoreAppOnboardingState,
    initState: ICoreAppOnboardingState
  ): void => {
    state.foo = initState.foo;
  },
};

export default mutations;
